import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IAttributes } from 'src/app/models/IAttributes';
import { IConsentforms } from 'src/app/models/IConsentforms';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { IProcedureCategory, IProceduresAllData, IprocedureLevels, IProcedureComponent } from 'src/app/models/IProcedures';
import { configuration } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsentFormsClinicService {

  constructor(private http: HttpClient) { }

  // saveConsentForms(ConsentFormInfo: IConsentforms): Observable<IConsentforms> {
  //   return this.http.post<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/SetConsentFormInstruction'}?facility=${sessionStorage.getItem("FacilityId")}`, ConsentFormInfo, {
  //   });
  // }

  saveConsentForms(ConsentFormInfo: IConsentforms): Observable<IConsentforms> {
    const signatureSizeImage = ConsentFormInfo.physicianSignature;
    ConsentFormInfo.physicianSignature = null;
    const posteddata = {
      inputdata: JSON.stringify(ConsentFormInfo),
      signature: (signatureSizeImage)
    }
    return this.http.post<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/SetConsentFormInstruction'}?facility=${sessionStorage.getItem("FacilityId")}`, posteddata, {
    });
  }

  // saveConsentFormsAuthorization(ConsentFormInfo: IConsentforms): Observable<IConsentforms> {
  //   return this.http.post<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/SetConsentFormsAuthorization'}?facility=${sessionStorage.getItem("FacilityId")}`, ConsentFormInfo, {
  //   });
  // }

  saveConsentFormsAuthorization(ConsentFormInfoAuth: IConsentforms): Observable<IConsentforms> {
    const signatureSizeImageAuth = ConsentFormInfoAuth.physicianSignatureAuth;
    ConsentFormInfoAuth.physicianSignatureAuth = null;
    const posteddata = {
      inputdata: JSON.stringify(ConsentFormInfoAuth),
      signature: (signatureSizeImageAuth)
    }
    return this.http.post<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/SetConsentFormsAuthorization'}?facility=${sessionStorage.getItem("FacilityId")}`, posteddata, {
    });
  }

  saveSpinalCord(ConsentFormInfo: IConsentforms): Observable<IConsentforms> {
    // const posteddata={
    //   inputdata:JSON.stringify(ConsentFormInfo)
    // }
    const signatureSizeImagePeinalCord = ConsentFormInfo.physicianSignature;
    ConsentFormInfo.physicianSignature = ConsentFormInfo.physicianSignature == true ? null : ConsentFormInfo.physicianSignature;
    if (ConsentFormInfo.physicianSignature == "Base64String%3A%20")
      ConsentFormInfo.physicianSignature = null;
    const posteddata = {
      inputdata: JSON.stringify(ConsentFormInfo),
      signature: (signatureSizeImagePeinalCord)
    }
    return this.http.post<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/AllConsentInformation'}?facilityId=${sessionStorage.getItem("FacilityId")}`, posteddata, {
    });
  }

  // saveSpinalCord(ConsentFormInfo: IConsentforms): Observable<IConsentforms> {
  //   return this.http.post<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/AllConsentInformation'}?facilityId=${sessionStorage.getItem("FacilityId")}`, ConsentFormInfo, {
  //   });
  // }

  saveVertiflex(ConsentFormInfo: IConsentforms): Observable<IConsentforms> {
    // const posteddata={
    //   inputdata:JSON.stringify(ConsentFormInfo)
    // } 
    const signatureSizeImageVertiflex = ConsentFormInfo.physicianSignature;
    ConsentFormInfo.physicianSignature = ConsentFormInfo.physicianSignature == true ? null : ConsentFormInfo.physicianSignature;;
    if (ConsentFormInfo.physicianSignature == "Base64String%3A%20")
      ConsentFormInfo.physicianSignature = null;
    const posteddata = {
      inputdata: JSON.stringify(ConsentFormInfo),
      signature: (signatureSizeImageVertiflex)
    }
    return this.http.post<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/AllConsentInformation'}?facilityId=${sessionStorage.getItem("FacilityId")}`, posteddata, {
    });
  }

  // saveVertiflex(ConsentFormInfo: IConsentforms): Observable<IConsentforms> {
  //   return this.http.post<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/AllConsentInformation'}?facilityId=${sessionStorage.getItem("FacilityId")}`, ConsentFormInfo, {
  //   });
  // }

  getServicebyEncounterId(encId: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/GetLocationByEncId'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);

  }

  getspinalCord(encId: string, type: string): Observable<IConsentforms> {
    return this.http.get<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/AllConsentInformation'}?userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}&&encounterId=${encId}&&consentType=${type}`); //&& userid=admin
  }

  getConsentForms(encId: string, userId: string): Observable<IConsentforms> {
    return this.http.get<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/getConsentForm'}?userid=${userId}&&encid=${encId}`); //&& userid=admin
  }

  getConsentAuthForms(encId: string, userId: string): Observable<IConsentforms> {
    return this.http.get<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/getConsentFormAuth'}?userid=${userId}&&encid=${encId}`); //&& userid=admin
  }

  userSignatureById(providerId: string, securityCode: string): Observable<IUserDetails> {
    return this.http.get<IUserDetails>
      (`${configuration.apiUrl + 'Admin/UserSignatureById'}?userid=${providerId}&&securityCode=${securityCode}&&facility=${sessionStorage.getItem("FacilityId")}`);

  }

  getProceduresByEncId(encId: string, patId: number): Observable<string> {
    return this.http.get<string>(
      `${configuration.clinicapiUrl + 'Encounter/GetProcedure'}?encId=${encId}&&patId=${patId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  getConsentFormSignatures(encId: string, userId: string): Observable<IConsentforms> {
    return this.http.get<IConsentforms>(`${configuration.clinicapiUrl + 'Encounter/getConsentFormSignatures'}?userid=${userId}&&encid=${encId}`); //&& userid=admin
  }

  getConsentDetailsByTitle(title: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/getConsentDescription'}?title=${title}&&facility=${sessionStorage.getItem("FacilityId")}`);

  }

  getDoclibConsentDetailsByTitle(title: string, Isreset: string, encId: string, PatID: number, userId: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/getDoclibConsentDescription'}?title=${title}&&Isreset=${Isreset}&&facility=${sessionStorage.getItem("FacilityId")}&&encid=${encId}&&PatId=${PatID}&&userid=${userId}&&locationid=${Number(sessionStorage.getItem("LocationId"))}`);

  }


  impupdateLockStatus(encounterId: string, isSignedOff: boolean, modified: string): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/impConsentUpdateLock'}?encounterId=${encounterId}&&isSignedOff=${isSignedOff}&&modifiedBy=${modified}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });

  }
}